export type SeededRng = () => number;

export function hashStringToUint32(input: string): number {
	let hash = 5381;
	for (let i = 0; i < input.length; i++) {
		hash = (hash * 33) ^ input.charCodeAt(i);
	}
	// Force to uint32
	return hash >>> 0;
}

// Mulberry32 PRNG: fast, deterministic, good enough for UI randomness.
export function createSeededRng(seedInput: string | number): SeededRng {
	let seed = typeof seedInput === 'number' ? seedInput >>> 0 : hashStringToUint32(seedInput);
	return () => {
		seed |= 0;
		seed = (seed + 0x6d2b79f5) | 0;
		let t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
		t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
		return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
	};
}

export function pickSeeded<T>(items: readonly T[], rng: SeededRng): T {
	if (items.length === 0) {
		throw new Error('pickSeeded: empty array');
	}
	const idx = Math.floor(rng() * items.length);
	return items[idx]!;
}

export function pickSeededIndex(length: number, rng: SeededRng): number {
	if (length <= 0) return 0;
	return Math.floor(rng() * length);
}

